import { useTranslation } from "react-i18next";
import { PMSimpleSelectorFieldV2 } from "../PMSimpleSelector/PMSimpleSelectorFieldV2";
import axios from "../../../api/axios";
import { useState, useEffect } from "react";
import { mapErrors } from "../../Utils";
import { Form, Formik } from "formik";
import { ResourceLoading } from "../ResourceLoading";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { PMField } from "../PMField";
import { useDispatch } from "react-redux";
import { create, debounce } from "lodash";
import { createserviceAgreementAsync } from "../../../slices/service/agreements";
import { ServiceAgreementTypeSimpleForm } from "../../dashboard/service/settings/types/simple-form";

export const ServiceAgreementTypeSelector = (props) => {
  const {
    setFieldValue,
    values,
    errors,
    onChange,
    module,
    module_param,
    fields,
  } = props;

  const name = "agreement_type_id";
  const label = "Agreement Type";
  const FETCH_URL = `/service/settings/agreement_types/`;
  const CREATE_URL = `/service/settings/agreement_types/`;
  const filters = null;

  const { t } = useTranslation();

  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({
    id: 0,
    field1: "Ingen valgt",
    field2: null,
  });
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const labelAction = {
    // path: "/dashboard/projects/" + selected?.id,
    // action: () => toast("test"),
  };

  const handleChange = (data) => {
    setLoading(false);

    setSelected({
      id: data?.selected?.item?.value,
      field1: data?.selected?.item?.primary,
    });

    setOpen(false);
    if (values) {
      setFieldValue(name, data.selected.item.id);
    } else {
      onChange({ target: { name: name, value: data.selected.item.id } });
    }
  };

  const handleSelect = (data) => {
    if (data?.id) {
      setSelected({
        id: data?.id,
        field1: data?.displayTitle,
      });
      setOpen(false);
    }
  };

  useEffect(() => {
    if (props?.selected?.id) {
      setSelected({
        id: props.selected?.id,
        field1: props.selected?.displayTitle,
      });
    } else {
      setSelected({
        id: null,
        field1: "Ingen valgt",
        field2: null,
      });
    }
  }, [props.selected]);

  const getItems = () => {
    setLoading(true);
    const params = {
      query: query ? query : "",
      page: 1,
      sortBy: "created_at",
      sort: "desc",
      filters: filters,
      view: null,
    };

    return axios({ method: "get", url: FETCH_URL, params: params })
      .then((response) => {
        if (response.data.data) {
          var array = [
            { id: null, value: null, primary: "Ingen valgt", secondary: null },
          ];
          if (!response.data.data) return array;
          response.data.data.map((row, i) => {
            const rowParams = {
              value: row.id,
              id: row.id,
              primary: row?.displayTitle,
              secondary: row?.description,
            };
            array.push(rowParams);
          });
          setItems(array);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        return error.response.data;
      });
  };

  const debouncedAction = debounce((controller) => {
    getItems();
  }, 500);

  useEffect(() => {
    if (open) {
      debouncedAction();
    }

    // Clean the debounced function on component unmount.
    return () => {
      debouncedAction.cancel();
    };
  }, [query, open]);

  return (
    <>
      <PMSimpleSelectorFieldV2
        errors={errors}
        name={name}
        label={t(label)}
        labelAction={labelAction}
        options={items}
        loading={loading}
        selected={selected}
        onChange={handleChange}
        onQueryChange={(query) => setQuery(query)}
        createView={
          <ServiceAgreementTypeSimpleForm
            loading={loading}
            onClose={() => setOpen(false)}
            onSelect={(data) => handleSelect(data)}
          />
        }
        onClose={() => setOpen(!open)}
        open={open}
      />
    </>
  );
};
